import logo from 'assets/brands/flare/logo.svg';
import sidebarLogo from 'assets/brands/flare/sidebarLogo.svg';

export const FLARE_CONFIGS = {
  logo,
  sidebarLogo,
  title: 'Flare',
};
